"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoggerUtils = void 0;
var SecurityConfig_1 = require("../interfaces/SecurityConfig");
var LogLevel_1 = require("../enums/LogLevel");
var uuid_1 = require("uuid");
var security_utils_1 = require("../security/security-utils");
var LogLevelKeys = Object.keys(LogLevel_1.LogLevel);
var loggerObjectProps = ['context', 'data', 'error', 'request', 'response'];
var LoggerUtils = (function () {
    function LoggerUtils() {
    }
    LoggerUtils.toBool = function (value, defaultValue) {
        if (defaultValue === void 0) { defaultValue = false; }
        switch (typeof value) {
            case 'undefined':
                return defaultValue;
            case 'boolean':
                return value;
            case 'string':
                return (value.toLowerCase() !== 'false');
        }
        return Boolean(value);
    };
    LoggerUtils.transposeKeyValue = function (input) {
        if (!input || typeof input !== 'object') {
            return;
        }
        var keys = Object.keys(input);
        var output = {};
        for (var i = 0; i < keys.length; i++) {
            var valueString = input[keys[i]].toString();
            var keyString = keys[i].toString();
            output[valueString] = keyString;
        }
        return output;
    };
    LoggerUtils.validateUILogInput = function (input) {
        if (!input) {
            return false;
        }
        else if (typeof input !== 'object') {
            return false;
        }
        else if (typeof input === 'object' && Object.keys(input).length === 0) {
            return false;
        }
        return true;
    };
    LoggerUtils.generateNewGlobalId = function () {
        return (0, uuid_1.v4)();
    };
    LoggerUtils.fastAndSafeJsonStringify = function (obj, fallback) {
        if (typeof obj === 'string') {
            return obj;
        }
        try {
            return JSON.stringify(obj);
        }
        catch (ex) {
            try {
                return JSON.stringify(obj, this.safeCycles());
            }
            catch (e) {
                return fallback || "Exception in JSON.stringify(obj): ".concat(e.message, ".");
            }
        }
    };
    LoggerUtils.deleteFields = function (rec) {
        for (var prop in loggerObjectProps) {
            var key = loggerObjectProps[prop];
            if (key === 'error' && rec && rec.level !== 'error') {
                var errorKeys = rec[key] && Object.keys(rec[key]);
                if (errorKeys && errorKeys.length === 1 && errorKeys[0] === 'isHumanRelated') {
                    delete rec[key];
                }
            }
            if (rec[key] && Object.keys(rec[key]).length === 0) {
                delete rec[key];
            }
        }
    };
    LoggerUtils.mapToErrorLog = function (errData) {
        var isHumanRelated = errData.isHumanRelated, code = errData.code, error = errData.error;
        var logErrorObj = { isHumanRelated: isHumanRelated };
        if (code) {
            logErrorObj.code = code;
        }
        if (error instanceof Error) {
            Object.assign(logErrorObj, LoggerUtils.prepareLogErrorObj(error));
        }
        if (errData.data) {
            logErrorObj.data = __assign(__assign({}, logErrorObj.data), errData.data);
        }
        if (!logErrorObj.stack && (error === null || error === void 0 ? void 0 : error.stack)) {
            logErrorObj.stack = error.stack;
        }
        if (error && (error instanceof String || error instanceof Number || error instanceof Boolean)) {
            var errorMsg = LoggerUtils.fastAndSafeJsonStringify(error, 'error');
            if (errorMsg && errorMsg !== '{}') {
                logErrorObj.message = logErrorObj.message ? errorMsg + logErrorObj.message : errorMsg;
            }
        }
        if (!logErrorObj.message && (error === null || error === void 0 ? void 0 : error.message)) {
            logErrorObj.message = error.message;
        }
        var messageFromError = (logErrorObj === null || logErrorObj === void 0 ? void 0 : logErrorObj.message) || LoggerUtils.fastAndSafeJsonStringify(error, 'error');
        logErrorObj.message = [errData.message, messageFromError].filter(function (x) { return x; }).join(': ') || 'error';
        return logErrorObj;
    };
    LoggerUtils.prepareLogErrorObj = function (_a) {
        var name = _a.name, stack = _a.stack, _message = _a.message, data = __rest(_a, ["name", "stack", "message"]);
        var logErrorObj = {};
        if (name) {
            logErrorObj.name = name;
        }
        if (stack) {
            logErrorObj.stack = stack;
        }
        if (Object.keys(data).includes('code')) {
            logErrorObj.code = data['code'];
            delete data['code'];
        }
        if (_message) {
            logErrorObj.message = _message;
        }
        if (Object.keys(data).includes('isHumanRelated')) {
            logErrorObj.isHumanRelated = data['isHumanRelated'];
            delete data['isHumanRelated'];
        }
        if (data && Object.keys(data).length > 0) {
            logErrorObj.data = Object.assign(logErrorObj.data || {}, { fromError: data });
        }
        return logErrorObj;
    };
    LoggerUtils.initializeChildLogger = function (log, rootValues, dataValues) {
        var piiLevel = rootValues && rootValues.context && rootValues.context.piiLevel;
        var context = (piiLevel !== undefined && piiLevel !== null) ?
            { piiLevel: piiLevel } : {};
        var isHumanRelated = rootValues && rootValues.error && rootValues.error.isHumanRelated;
        var error = (isHumanRelated !== undefined && isHumanRelated !== null) ?
            { isHumanRelated: isHumanRelated } : {};
        return log.child({ defaultModule: rootValues && rootValues.module,
            defaultCategory: rootValues && rootValues.category, defaultContext: context, defaultError: error, defaultData: dataValues });
    };
    LoggerUtils.applyOverridesToLogLevelFunctions = function (log) {
        for (var level in LogLevelKeys) {
            this.overrideLogFunctions(log, LogLevelKeys[level], log[LogLevelKeys[level]]);
        }
    };
    LoggerUtils.preProcessErrorObject = function (logObject, defaultErrorIsHumanRelated) {
        var errorObject = logObject instanceof Error ? logObject : logObject.error;
        var argsErrorIsHumanRelated = errorObject && errorObject.isHumanRelated;
        var data = errorObject && errorObject.data;
        var code = errorObject && errorObject.code;
        var message = errorObject && (errorObject.message || errorObject.name) || 'error';
        var isHumanRelated = (typeof argsErrorIsHumanRelated === 'boolean') ? argsErrorIsHumanRelated : defaultErrorIsHumanRelated;
        var errorData = {
            isHumanRelated: isHumanRelated,
            data: data,
            code: code,
            error: logObject instanceof Error ? Object.assign(logObject || {}, { message: message }) :
                Object.assign(logObject.error || {}, { message: message })
        };
        var error = this.mapToErrorLog(errorData);
        return error;
    };
    LoggerUtils.getLocalStorageContext = function (log) {
        return log.getContextFromLocalStorage();
    };
    LoggerUtils.fetchHighestPriorityPiiLevelIfExist = function (piiLevels) {
        var piiLevelIndex = Infinity;
        for (var i = 0; i < piiLevels.length; i++) {
            var currentPiiLevel = piiLevels[i];
            var lowerCaseCurrentPiiLevel = currentPiiLevel && typeof currentPiiLevel === 'string'
                && currentPiiLevel.toLowerCase();
            if (security_utils_1.SecurityUtils.isValidPiiLevel(lowerCaseCurrentPiiLevel)) {
                var priorityLevelIndex = SecurityConfig_1.PiiLevelPriority.indexOf(lowerCaseCurrentPiiLevel);
                if (priorityLevelIndex < piiLevelIndex) {
                    piiLevelIndex = priorityLevelIndex;
                }
            }
        }
        return piiLevelIndex;
    };
    LoggerUtils.safeCycles = function () {
        var seen = new Set();
        return function (key, val) {
            if (!val || typeof (val) !== 'object') {
                return val;
            }
            if (seen.has(val)) {
                return '[Circular]';
            }
            seen.add(val);
            return val;
        };
    };
    LoggerUtils.fetchPiiLevelToUse = function (fields, log, logContextPiiLevel) {
        var childLoggerContextPiiLevel = fields && fields.defaultContext && fields.defaultContext.piiLevel;
        var contextLocalStorage = log['getContextFromLocalStorage'] ? this.getLocalStorageContext(log) : undefined;
        var contextLocalStoragePiiLevel = contextLocalStorage && contextLocalStorage.piiLevel;
        var piiLevels = [logContextPiiLevel, childLoggerContextPiiLevel, contextLocalStoragePiiLevel];
        var PiiLevelIndex = this.fetchHighestPriorityPiiLevelIfExist(piiLevels);
        if (PiiLevelIndex !== Infinity) {
            return SecurityConfig_1.PiiLevelPriority[PiiLevelIndex];
        }
        return logContextPiiLevel || childLoggerContextPiiLevel || contextLocalStoragePiiLevel;
    };
    LoggerUtils.preProcessDataObject = function (data, clonedLogObject) {
        if (data && Object.keys(data).length > 0) {
            return Object.assign({}, data, clonedLogObject && clonedLogObject.data);
        }
        return clonedLogObject && clonedLogObject.data;
    };
    LoggerUtils.preProcessAdditionalStringParams = function (options) {
        var functionName = JSON.parse(JSON.stringify(options.props[options.startIndex + 1]));
        var context = options.piiLevel ? { piiLevel: options.piiLevel } : {};
        var sliceParam = (options.props[options.startIndex + 2] &&
            typeof options.props[options.startIndex + 2] === 'string') ?
            options.startIndex + 3 : options.startIndex + 2;
        return options.logFunction.apply(options.log, __spreadArray([
            { message: options.props[options.startIndex], context: context, function: functionName }
        ], options.props.slice(sliceParam), true));
    };
    LoggerUtils.overrideLogFunctions = function (log, logLevel, logFunction) {
        var _this = this;
        log[logLevel] = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var fields = log && log['fields'];
            var defaultErrorIsHumanRelated = fields && fields.defaultError &&
                Object.keys(fields.defaultError).includes('isHumanRelated') ?
                fields.defaultError.isHumanRelated : undefined;
            var data = fields && fields.defaultData;
            var properties = args && Array.isArray(args) ? args.slice() : args;
            if (Array.isArray(properties) && properties.length > 0) {
                if (typeof properties[0] === 'object') {
                    var logObject = {};
                    logObject = Object.assign({}, !(properties[0] instanceof Error) ? properties[0] : {});
                    if (properties[0] && (properties[0] instanceof Error || Object.keys(properties[0]).includes('error'))) {
                        logObject.error = _this.preProcessErrorObject(properties[0], defaultErrorIsHumanRelated);
                    }
                    else {
                        if (defaultErrorIsHumanRelated !== undefined) {
                            logObject.error = { isHumanRelated: defaultErrorIsHumanRelated };
                        }
                    }
                    logObject.data = _this.preProcessDataObject(data, properties[0]);
                    var logsPiiLevel = properties[0] && properties[0].context &&
                        properties[0].context.piiLevel;
                    var piiLevelToUse = _this.fetchPiiLevelToUse(fields, log, logsPiiLevel);
                    if (piiLevelToUse) {
                        logObject.context && typeof logObject.context === 'object' ? logObject.context.piiLevel = piiLevelToUse
                            : logObject.context = { piiLevel: piiLevelToUse };
                    }
                    var argArrayWithLogObject = __spreadArray([logObject], properties.slice(1), true);
                    return logFunction.apply(log, argArrayWithLogObject);
                }
                var startIndex = 0;
                if (typeof properties[startIndex] === 'string' && typeof properties[startIndex + 1] === 'string'
                    && logLevel === LogLevel_1.LogLevel.info) {
                    var logsPiiLevel = typeof properties[startIndex + 2] === 'string' && properties[startIndex + 2];
                    var piiLevelToUse = _this.fetchPiiLevelToUse(fields, log, logsPiiLevel);
                    var options = {
                        props: properties,
                        startIndex: startIndex,
                        piiLevel: piiLevelToUse,
                        log: log,
                        logFunction: logFunction
                    };
                    return _this.preProcessAdditionalStringParams(options);
                }
            }
            return logFunction.apply(log, properties);
        };
    };
    LoggerUtils.parseStringifiedObjects = function (stringifiedLog) {
        try {
            return JSON.parse(stringifiedLog);
        }
        catch (error) {
            throw new Error("Error encountered during initial parsing of stringified log - ".concat(stringifiedLog));
        }
    };
    LoggerUtils.resolveChildLoggerDefaults = function (rec) {
        rec.module = rec.module || rec.defaultModule;
        rec.category = rec.category || rec.defaultCategory;
        rec.data = rec.data || rec.defaultData;
        delete rec.defaultError;
        delete rec.defaultContext;
        delete rec.defaultModule;
        delete rec.defaultCategory;
        delete rec.defaultData;
    };
    LoggerUtils.populateMissingRequiredFields = function (rec, config, logLevels, populateContextFromLocalStorage) {
        rec.message = rec.message || '';
        var space = (rec.message && rec.message.length > 0) ? ' ' : '';
        if (rec.msg && typeof rec.msg !== 'string') {
            rec.msg = LoggerUtils.fastAndSafeJsonStringify(rec.msg);
        }
        rec.message = (rec.msg && rec.msg.length > 0) ? (rec.message + space + rec.msg) : rec.message;
        rec.environment = config.environment;
        rec.appVersion = config.appVersion;
        rec.level = logLevels[rec.level].toString() || rec.level;
        if (populateContextFromLocalStorage) {
            populateContextFromLocalStorage(rec);
        }
        delete rec.msg;
        delete rec.v;
        delete rec.levelName;
    };
    LoggerUtils.resolveCollision = function (rec) {
        if (rec.err && !rec.error) {
            rec.error = rec.err;
            delete rec.err;
        }
        if (rec.name && !rec.app) {
            rec.app = rec.name;
            delete rec.name;
        }
        if (rec.req && !rec.request) {
            rec.request = rec.req;
            delete rec.req;
        }
        if (rec.res && !rec.response) {
            rec.response = rec.res;
            delete rec.res;
        }
    };
    LoggerUtils.stringifyDataObject = function (rec) {
        if (rec.data) {
            rec.data = LoggerUtils.fastAndSafeJsonStringify(rec.data);
        }
        if (rec.request && rec.request.data) {
            rec.request.data = LoggerUtils.fastAndSafeJsonStringify(rec.request.data);
        }
        if (rec.response && rec.response.data) {
            rec.response.data = LoggerUtils.fastAndSafeJsonStringify(rec.response.data);
        }
        if (rec.context && rec.context.data) {
            rec.context.data = LoggerUtils.fastAndSafeJsonStringify(rec.context.data);
        }
        if (rec.error && rec.error.data) {
            rec.error.data = LoggerUtils.fastAndSafeJsonStringify(rec.error.data);
        }
    };
    LoggerUtils.setTimeFields = function (rec) {
        rec.timestamp = rec.time || new Date();
        if (rec.time) {
            delete rec.time;
        }
        if (rec.timestamp && typeof rec.timestamp === 'object') {
            rec.timestamp = rec.timestamp.toISOString();
        }
    };
    LoggerUtils.reAssignPiiLevel = function (rec) {
        if (rec.context && rec.context.piiLevel) {
            rec.context.piiLevel = SecurityConfig_1.PiiLevelEnum.s1;
        }
        else {
            rec.context && typeof rec.context === 'object' ? rec.context.piiLevel = SecurityConfig_1.PiiLevelEnum.s1 :
                rec.context = { piiLevel: SecurityConfig_1.PiiLevelEnum.s1 };
        }
    };
    LoggerUtils.assignErrorCode = function (rec) {
        if (rec.error && typeof rec.error === 'object' && rec.error.code) {
            rec.error.code = "".concat("HT_LOGGER_10002", " ").concat(rec.error.code);
        }
        else {
            rec.error && typeof rec.error === 'object' ? rec.error.code = "HT_LOGGER_10002" :
                rec.error = { code: "HT_LOGGER_10002" };
        }
    };
    LoggerUtils.assignErrorMessage = function (rec, errorMessage) {
        var genericErrorMessage = 'Error encountered while transforming, validating and writing logs.';
        var catchError = "Logger message: ".concat(genericErrorMessage, " Logger exception message: ").concat(errorMessage);
        if (rec.message && typeof rec.message === 'string') {
            rec.message = "".concat(rec.message, ". ").concat(catchError);
        }
        else {
            rec.message = "".concat(catchError);
        }
    };
    return LoggerUtils;
}());
exports.LoggerUtils = LoggerUtils;
